<template>
  <ConfigurationSection
    :configuration="preset.baseConfiguration"
    :precedence="precedence"
    section-type="preset"
    :section-title="preset.presetInfo.presetName"
    :section-description="preset.presetInfo.description"
    :section-icon="getPresetIcon(preset.presetInfo.presetType)"
    :section-badge="{
      text: preset.presetInfo.presetType,
      variant: getPresetVariant()
    }"
    :preset-context="preset.presetInfo"
    :is-highlighted="isHighlighted"
    @section-interaction="notifyInteraction"
  />
</template>

<script setup lang="ts">
import { getPresetIcon } from '@/utils/presetIcons'
import ConfigurationSection from '@/components/organisms/ConfigurationSection.vue'
import type { PresetConfiguration } from '@/types/configuration'

interface Props {
  preset: PresetConfiguration
  precedence?: number
  isHighlighted?: boolean
}

defineProps<Props>()

// Export the Props interface
export type PresetSectionProps = Props

// Emits
const emit = defineEmits<{
  'node-interaction': []
}>()

// Helper function
function getPresetVariant(): 'info' {
  // Set all preset badges to info variant for all presets
  return 'info'
}

// Event handlers
function notifyInteraction() {
  emit('node-interaction')
}
</script>
